import { t } from '../../helpers/translation.helper';
import { RecipientRole } from '../types/enums/recipient-role';

export class RecipientsHelper {
  static getTranslatedRole(role: RecipientRole) {
    switch (role) {
      case RecipientRole.CC:
        return t('cc');
      case RecipientRole.Signer:
        return t('signer');
      case RecipientRole.ExternalApprover:
        return t('external_approver');
      case RecipientRole.Approver:
        return t('internal-approver');
      default:
        return '';
    }
  }
}
